"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const router_1 = require("../../misc/router");
exports.Link = React.forwardRef((props, ref) => {
    const props2 = { ...props, ref };
    return (React.createElement(router_1.Link, { ...props2 },
        props.children,
        props.external ? ' ↗' : ''));
});
